class LandingBanner extends HTMLElement {
	constructor() {
		super(); 
	}

    connectedCallback() {
       const button = this.querySelector('#landing-banner__button')

       // Set initial button text in variable to reusue on mouseout
       const initialText = button.innerText

       // Mouseover event to change style and text
       button.addEventListener('mouseover', (e) => {
         const hoverText = button.dataset.hover 
         
        //  Set Width and height of button so it doesn't contract when smaller text is shown
         button.style.width = button.offsetWidth + 'px';
         button.style.height = button.offsetHeight + 'px';

         button.innerText = hoverText
       })

       // Mouseout event to change style and text
       button.addEventListener('mouseout', (e) => {
        button.innerText = initialText
        button.style.width = 'auto';
        button.style.height = 'auto';
      })
    }
}


customElements.define('landing-banner', LandingBanner);